/* eslint-disable no-param-reassign */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-expressions */
import Axios from 'axios';
import bytes from 'bytes';
import CryptoJS from 'crypto-js';
import * as Sentry from '@sentry/react';
import {
  CONTEXT,
  MICROCONTEXT,
  APP_VERSION,
  APP_VERSION_D,
  APP_VERSION_CODE,
  APP_VERSION_CODE_D,
  REGISTER_URL,
  REPORT_LOG_URL,
} from '../config';
import { cacheKeys, GUI_MODE_INFO } from '../constants/storageKeys';
import { PCStoreJsBridge } from '../nativeapi';
import { SET_INTERFACE_STATUS } from '../constants/network';

import { store } from '../index';
import { message } from 'antd';
import { MENUS, MENUS_SMB } from '../constants/layout';

let regTokenStep = -1; // -1:初始值 0：正在请求 1：请求成功

// 请求开始的处理
Axios.interceptors.request.use(config => {
  // 请求REQUEST_ID url timestamp 上报
  config.REQUEST_ID = Date.now();
  return config;
});

// 请求结束的处理
Axios.interceptors.response.use(
  response => {
    const { config } = response;
    // // 请求时长>200ms 上报这个桩
    // if (Date.now() - config.REQUEST_ID > 300) {
    //   logging({
    //     category: 'M',
    //     action: 'End_api',
    //     label: '',
    //     param2: {
    //       service: config.url,
    //       status: 1,
    //       time: Date.now() - config.REQUEST_ID,
    //     },
    //   });
    // }
    response.status === 200
      ? logNative(`http请求 结束请求：${config.url}`, { status: response.status }, false, true)
      : logNative(`http请求 结束请求：${config.url}`, { status: response.status }, true);

    if (response.data && response.data.status && response.data.status.toString() === '502') {
      // token 过期 自动注册 Token 重新请求
      if (regTokenStep === -1) {
        regTokenStep = 0;
        const regInfo = localStorage.getItem(cacheKeys.LOCALMACHINE_INFO);
        registerToken(JSON.parse(regInfo))
          .then(token => {
            regTokenStep = 1;
            response.config.headers.token = token;
            return Axios.request(response.config);
          })
          .catch(() => {
            regTokenStep = -1;
          });
      }

      if (regTokenStep === 0) {
        return Axios.request(response.config);
      }

      if (regTokenStep === 1) {
        const token = localStorage.getItem(cacheKeys.REGISTER_TOKEN);
        response.config.headers.token = token;
        return Axios.request(response.config);
      }
    }

    return response;
  },
  error => {
    // 有响应
    if (error && error.response) {
      const { config = {} } = error.response;
      // logging({
      //   category: 'M',
      //   action: 'End_api_Error',
      //   label: '',
      //   param2: {
      //     service: config.url,
      //     status: error.response && error.response.status,
      //     time: Date.now() - config.REQUEST_ID,
      //     mes: error.message,
      //   },
      // });

      // 登录信息userToken过期处理401错误
      if (error.response.status === 401) {
        if (regTokenStep === -1) {
          regTokenStep = 0;
          const userTokenParam = { data: {} };
          userTokenParam.data[cacheKeys.X_LESYNC_TOKEN] =
            localStorage.getItem(cacheKeys.X_LESYNC_TOKEN) || '';
          // 重新获取更新的userToken
          return PCStoreJsBridge.getUserTokenInfo(userTokenParam)
            .then(res => {
              regTokenStep = 1;
              if (res && res[cacheKeys.X_LESYNC_TOKEN]) {
                const userToken = res[cacheKeys.X_LESYNC_TOKEN];
                // 更改请求header中的ltoken，并且更改localStorage的X_LESYNC_TOKEN信息
                config.headers.ltoken = userToken;
                localStorage.setItem(cacheKeys.X_LESYNC_TOKEN, userToken);
              }
              const instance = Axios.create();
              return instance(config);
              // return Axios.request(error.response.config);
            })
            .catch(e => {
              logNative(`http请求 遇到401错误但是重新获取userToken失败 ${e}`, e);
              regTokenStep = -1;
            });
        }
      }
    }

    return null;
  },
);

export async function loggingADX(urlArr = []) {
  urlArr.forEach(url => {
    Axios.get(url.toString())
      .then(res => {
        logNative(
          `ADX 打桩请求结束 地址：${url}, 请求结果：${JSON.stringify(res)}`,
          {},
          true,
          true,
        );
      })
      .catch(err => {
        logNative(`ADX 打桩请求错误 地址：${url}, 请求结果：${err}`, {});
        throw err;
      });
  });
}

export async function registerToken(registryInfo) {
  // 注册API接口 获取 Token 保存到 localStorage
  return Axios.post(REGISTER_URL, {
    ch: APP_VERSION,
    mac: registryInfo.MAC,
    mt: registryInfo.MT,
    os: registryInfo.OS,
    osBit: registryInfo.OSbit,
    sn: registryInfo.SN,
    uuid: registryInfo.ludp_uuid,
  })
    .then(res => {
      if (res.data.data) {
        localStorage.setItem(cacheKeys.REGISTER_TOKEN, res.data.data);
        return Promise.resolve(res.data.data);
      }
      throw new Error('register token  failed');
    })
    .catch(err => {
      throw err;
    });
}

export async function createSignature(param) {
  let signature = '';
  let userText = param?.userText || '';
  let timestamp = param?.timestamp || +new Date();
  try {
    const machineInfoStr = localStorage.getItem(cacheKeys.LOCALMACHINE_INFO);
    const machineInfo = JSON.parse(machineInfoStr);
    let str = `${machineInfo?.ludp_uuid}&${userText}&${timestamp}`;
    let key = 'DpZZ3pBf5GXU4+Omlh3tjzh2fyw=';
    signature = CryptoJS?.HmacSHA1(str, key).toString();
    logNative(`AIGC createSignature ${str} ${signature}`);
  } catch (error) {
    let str = `${timestamp}&${userText}&${timestamp}`;
    signature = CryptoJS?.HmacSHA1(str, 'DpZZ3pBf5GXU4+Omlh3tjzh2fyw=').toString();
  }
  return signature;
}

export async function createAxiosGameCDK() {
  let token = '';
  try {
    const userInfo = JSON.parse(localStorage.getItem('USER_INFO'));
    token = userInfo?.st || '';
  } catch (error) {}
  Axios.defaults.headers.common.realm = 'pcassistant.lenovo.com';
  Axios.defaults.headers.common.token = token || '';
  return Axios;
}

export async function createAxios(need, param) {
  let token = localStorage.getItem(cacheKeys.REGISTER_TOKEN);
  const machineInfo = localStorage.getItem(cacheKeys.LOCALMACHINE_INFO);
  if (!token) {
    if (machineInfo) {
      token = await registerToken(JSON.parse(machineInfo));
      localStorage.setItem(cacheKeys.REGISTER_TOKEN, token);
    } else {
      const regInfo = await PCStoreJsBridge.getLocalMachineInfo();
      token = await registerToken(regInfo);
    }
  }
  // http header 中放入vt参数
  let vt = localStorage.getItem(cacheKeys.IS_VT_ENABLE);
  if (vt === null) {
    const isVTEnable = await PCStoreJsBridge.getIsVTEabled();
    vt = isVTEnable.vt ? '1' : '0';
    localStorage.setItem(cacheKeys.IS_VT_ENABLE, vt);
  }
  // 是否为AIGC接口需要的参数
  if (need === 'isAIGC' && param?.userText) {
    Axios.defaults.headers.common['Content-Type'] = 'application/json';
    Axios.defaults.headers.common['signature'] = await createSignature(param);
  }
  // http header 中放入user token(即：ltoken)参数
  if (need === 'isNeedUser') {
    const userToken = await getUserToken();
    Axios.defaults.headers.common.ltoken = userToken;
  }
  Axios.defaults.headers.common.token = token;
  Axios.defaults.headers.common.vt = vt;
  Axios.defaults.headers.common.productCode = 2;
  // 8.5 壁纸频道新增header
  Axios.defaults.headers.common.clientType = 1;
  // h5支持的功能（例如：1011）
  // 第一位指：5.5能力（是否支持专题）
  // 第二位指：6.0能力（card增加专题list card，和商城 card）
  // 第三位指：6.5能力（card增加 商城弹框 card）
  // 第四位指：7.1能力（banner支持OtherPage）
  // 第五位指：7.2论坛能力（banner支持OtherPage）
  // 第六位指：7.5新增三方游戏购买
  // 第七位指：8.0壁纸商业化
  // 第八位指：8.4单机付费软件
  // 第九位指：8.6游戏频道改版
  // 第十位指：8.7应用预约
  // 第十一位指： 8.8 壁纸sku支持配置
  // 第十二位指： 9.0.11 游戏cdk购买
  Axios.defaults.headers.common.h5need = '111111111111';

  // 设置系统模式btoken
  try {
    let guiModeInfo = JSON.parse(localGetItem(GUI_MODE_INFO) || '{}');

    if (guiModeInfo && guiModeInfo.businessCode && guiModeInfo.btoken && guiModeInfo.guiMode) {
      Axios.defaults.headers.common.btoken = guiModeInfo.btoken || '';
    }
  } catch (e) {
    logNative(`分析系统模式参数 guiModeInfo JSON解析错误:${e}`, e);
  }

  return Axios;
}

export async function getUserToken() {
  let userToken = '';
  userToken = localStorage.getItem(cacheKeys.X_LESYNC_TOKEN) || '';

  if (!userToken || userToken === 'undefined') {
    const res = await PCStoreJsBridge.getUserTokenInfo();
    if (res && res[cacheKeys.X_LESYNC_TOKEN]) {
      userToken = res[cacheKeys.X_LESYNC_TOKEN] || '';
      localStorage.setItem(cacheKeys.X_LESYNC_TOKEN, userToken);
    }
  }
  return userToken;
}

export function imgLocalUrl(url) {
  return `http://pcm/file:///${encodeURIComponent(url)}`;
}

export function sumAll(arr) {
  let sum = 0;
  let i = 0;
  for (i; i < arr.length; i += 1) {
    sum += Number(arr[i].estimateSize);
  }
  return bytes(sum, { unitSeparator: ' ' });
}

// native安装的 key需要转成首字母大写，不然就没法下载
export function capitalizeObj(obj) {
  if (typeof obj !== 'object') {
    return obj;
  }
  const capitalObj = {};
  for (const orgKey in obj) {
    const key = orgKey.charAt(0).toUpperCase() + orgKey.slice(1);
    if (!capitalObj[key] && obj[orgKey]) {
      capitalObj[key] = obj[orgKey];
    }
    // capitalObj[key] = obj[orgKey];
  }
  return capitalObj;
}

// 首字母转小写
export function camelizeObj(obj) {
  if (typeof obj !== 'object') {
    return obj;
  }
  const camelizeRet = {};
  for (const orgKey in obj) {
    const key = orgKey.charAt(0).toLowerCase() + orgKey.slice(1);
    if (!camelizeRet[key] && obj[orgKey]) {
      camelizeRet[key] = obj[orgKey];
    }
    // camelizeRet[key] = obj[orgKey];
  }
  return camelizeRet;
}

export function renderSize(value) {
  if (null == value || value == '' || value < 1000) {
    return '0KB';
  }
  var unitArr = new Array('Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB');
  var index = 0;
  var srcsize = parseFloat(value);
  index = Math.floor(Math.log(srcsize) / Math.log(1024));
  var size = srcsize / Math.pow(1024, index);
  size = size.toFixed(2); //保留的小数位数
  return size + unitArr[index];
}

export function hasClass(el, className) {
  if (!el || !className) return false;
  if (className.indexOf(' ') !== -1) throw new Error('className存在非法空格');
  if (el.classList) {
    return el.classList.contains(className);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + className + ' ') > -1;
  }
}

export function addClass(el, className) {
  if (!el || hasClass(el, className)) {
    return;
  }
  const newClass = el.className.split(' ');
  newClass.push(className);
  el.className = newClass.join(' ');
}

/**
 * 追加class
 * @param {Element} el
 * @param {String} cls 需要添加的 class 名，多个用空格分隔
 * @returns void
 */
function addClassNew(el, cls) {
  if (!el) return;
  let curClass = el.className;
  const classes = (cls || '').split(' ');

  for (let i = 0, j = classes.length; i < j; i++) {
    const clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
}

/**
 * 移除class
 * @param {Element} el
 * @param {String} cls 需要移除的 class 名，多个用空格分隔
 * @returns void
 */
export function removeClass(el, cls) {
  if (!el || !cls) return;
  const classes = cls.split(' ');
  let curClass = ' ' + el.className + ' ';

  for (let i = 0, j = classes.length; i < j; i++) {
    const clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }
}

export function changeClass(el, newClassName, oldClassName) {
  oldClassName && removeClass(el, oldClassName);
  newClassName && addClass(el, newClassName);
}
/**
 * 去除非法空格
 * @param {String} string
 * @returns {String}
 */
export function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
}

// 获取url中&后面的参数 需要decodeURIComponent
export function getQueryString(key, url) {
  url = url || window.location.search;
  const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`);
  const r = url.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return '';
}

// 获取url中&后面的参数
export function getQueryString2(key, url) {
  url = url || window.location.search;
  const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`);
  const r = url.substr(1).match(reg);
  if (r != null) {
    return r[2];
  }
  return '';
}
// 获取url中&后面的参数 需要转码
export function getQueryString3(key, url) {
  url = url || window.location.search;
  const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`);
  const r = url.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return '';
}

// 获取url中#后面的参数 需要decodeURIComponent
export function getParamString(key, string) {
  const reg = new RegExp(`(^|#)${key}=([^#]*)(#|$)`);
  const r = string.substr(1).match(reg);
  if (r != null) {
    const cont = decodeURIComponent(r[2]);
    if (cont.indexOf(' ') > -1) {
      return cont.split(' ')[0];
    }
    return cont;
  }
  return '';
}

// 获取url中#后面的参数 不需要decodeURIComponent
export function getParamString2(key, string) {
  const reg = new RegExp(`(^|#)${key}=([^#]*)(#|$)`);
  const r = string.substr(1).match(reg);
  if (r != null) {
    const cont = r[2];
    if (cont.indexOf(' ') > -1) {
      return cont.split(' ')[0];
    }
    return cont;
  }
  return '';
}

// 不处理空格
export function getParamString3(key, string) {
  const reg = new RegExp(`(^|#)${key}=([^#]*)(#|$)`);
  const r = string.substr(1).match(reg);
  if (r != null) {
    const cont = r[2];
    // if (cont.indexOf(' ') > -1) {
    //   return cont.split(' ')[0];
    // }
    return cont;
  }
  return '';
}

export function getDefaultPage() {
  let guiModeInfo = JSON.parse(localGetItem(GUI_MODE_INFO) || '{}');
  const defaultPage = guiModeInfo.businessCode === 'SMB' ? MENUS_SMB : MENUS;
  return `${CONTEXT}/${defaultPage[0]}`;
}

// 获取软件类型：0 正常PC、1 正常安卓、3 纯网页应用、12 PC单机付费、10 网页版购买、11 弹框购买
export function getSoftType(soft) {
  /**
   * softType:
   * 0: PC软件
   * 1: 安卓软件
   * 3: 纯网页应用，例如知乎
   * 10: 网页版购买   即 soft?.androidType === '3' && sourceType=== 0  例如鬼泣4
   * 11: 游戏CDK弹框购买(老)     即 soft?.androidType === '3' && sourceType === 1
   * 11: 凤凰游戏CDK弹框购买   即 soft?.androidType === '3' && sourceType === 2
   * 12: 单机付费       即 soft?.androidType === '0' && soft?.payType === 1
   */
  // 正常PC
  if ((!soft?.androidType || soft?.androidType === '0') && soft?.payType !== 1) {
    return '0';
  }
  // 正常安卓
  if (soft?.androidType === '1') {
    return '1';
  }
  // 纯网页应用
  if (soft?.androidType === '2') {
    return '3';
  }
  if (soft?.androidType === '3') {
    if (soft?.sourceInfo && soft?.sourceInfo?.sourceType === 0) {
      return '10'; // 网页版购买
    }
    if (soft?.sourceInfo && soft?.sourceInfo?.sourceType === 1) {
      return '11';
    }
    if (soft?.sourceInfo && soft?.sourceInfo?.sourceType === 2) {
      return '11';
    }
    return '10';
  }
  // 单机付费
  if ((!soft?.androidType || soft?.androidType === '0') && soft?.payType === 1) {
    return '12';
  }
  return '';
}

/**
 * 只是生成内部的跳转url，游戏页面使用
 * @param {*} info
 */
export function generateURL(info = {}) {
  // 跳转外部链接
  if (info.targetType === '2') {
    if (info.targetUrl) {
      return {
        external: true,
        url: info.targetUrl,
      };
    }

    if (info.targetContent) {
      try {
        const { targetUrl } = JSON.parse(info.targetContent);
        if (!targetUrl) throw new Error('targetUrl does not exist');
        return {
          external: true,
          url: targetUrl,
        };
      } catch (e) {
        logNative(`分析URL generateURL JSON解析错误:${e}`, e);
      }
    }
  }

  // 跳转外部链接（定义的ADX广告）
  if (info.targetType === '10') {
    if (info.advertUrl) {
      return {
        external: true,
        url: info.advertUrl,
      };
    }

    if (info.targetContent) {
      try {
        const { advertUrl } = JSON.parse(info.targetContent);
        if (!advertUrl) throw new Error('advertUrl does not exist');
        return {
          external: true,
          url: advertUrl,
        };
      } catch (e) {
        logNative(`分析URL generateURL JSON解析错误:${e}`, e);
      }
    }
  }

  // 跳商品购买弹窗
  if (info.targetType === '5' && info.targetContent) {
    try {
      const { url } = JSON.parse(info.targetContent);
      if (!url) throw new Error('url does not exist');
      return {
        pay: true,
        url,
      };
    } catch (e) {
      logNative(`分析URL generateURL JSON解析错误:${e}`, e);
    }
  }

  return { url: getUrlByTargetContent(info) };
}

/**
 * 只是生成内部的跳转url
 * @param {*} info
 */
export function getUrlByTargetContent(info) {
  let url = getDefaultPage();
  // 应用详情页面
  if (info.targetType === '1' && info.appInfo) {
    if (info.appInfo.androidType === '1') {
      url = `${CONTEXT}/adetail/${info.appInfo.packageName}/${
        info.appInfo.versionCode
      }/${encodeURIComponent(info.appInfo.bizInfo || '{}')}`;
    } else {
      url = `${CONTEXT}/detail/soft/${info.appInfo.softID || ''}/${encodeURIComponent(
        info.appInfo.bizInfo || '{}',
      )}`;
    }
  }

  // 专题详情页面
  if (info.targetType === '3' && info.ztId) {
    url = `${CONTEXT}/special?ztId=${info.ztId}&bannerId=${info.pageCardContentId || ''}`;
  }

  // 仅仅处理iframe其他页面，7.1新增
  if (info.targetType === '12' && info.targetContent) {
    let targetContent = {};
    if (typeof info.targetContent === 'string') {
      try {
        targetContent = JSON.parse(info.targetContent);
      } catch (error) {
        logNative(`分析URL getUrlByTargetContent JSON解析错误:${error}`, error);
      }
    } else {
      targetContent = info.targetContent;
    }
    url = `${CONTEXT}/otherpage?pageUrl=${encodeURIComponent(
      targetContent.url,
    )}&bizInfo=${encodeURIComponent('{}')}`;
  }

  // 其他页面  6.5新增
  if (info.targetType === '11' && info.targetContent) {
    let targetContent = {};
    if (typeof info.targetContent === 'string') {
      try {
        targetContent = JSON.parse(info.targetContent);
      } catch (error) {
        logNative(`分析URL getUrlByTargetContent JSON解析错误:${error}`, error);
      }
    } else {
      targetContent = info.targetContent;
    }
    // 游戏菜单现在是动态配置了，不能硬编码了
    if (/^game\//.test(targetContent.targetPage)) {
      url = `${CONTEXT}/${targetContent.targetPage}`;

      if (targetContent.targetPage === 'game/gameLibrary') {
        url += `?code=${targetContent.code || ''}&childCode=${targetContent.childCode || ''}`;
      } else if (targetContent.targetPage === 'game/gameRank' && targetContent.code) {
        url += `/${targetContent.code}`;
      }
      return url;
    }
    switch (targetContent.targetPage) {
      case 'recommend':
        url = `${CONTEXT}/recommend`;
        break;
      // case 'education':
      //   url = `${CONTEXT}/education`;
      //   break;
      case 'edurecommend':
        url = `${CONTEXT}/education/`;
        break;
      case 'education':
        url = `${CONTEXT}/education/`;
        break;
      case 'educategory':
        url = `${CONTEXT}/education/category?gradeId=${targetContent.gradeId || ''}&subjectId=${
          targetContent.subjectId || ''
        }&phaseId=${targetContent.phaseId || ''}`;
        break;
      case 'edumine':
        url = `${CONTEXT}/education/mine?tag=${targetContent.tag || ''}`;
        break;
      case 'edudetail':
        url = `${CONTEXT}/edudetail?courseId=${targetContent.courseId || ''}&studyState=${
          targetContent.studyState || ''
        }&bizInfo=${targetContent.bizInfo || '{}'}`;
        break;
      case 'work':
        url = `${CONTEXT}/work`;
        break;
      case 'wprecommend':
        url = `${CONTEXT}/wallpaper/wprecommend`;
        break;
      case 'wpauthordetail':
        url = `${CONTEXT}/wpauthordetail?authorId=${targetContent.authorId || ''}`;
        break;
      case 'wprank':
        url = `${CONTEXT}/wprank?code=${targetContent.rankId}`;
        break;
      case 'wpdetail':
        url = `${CONTEXT}/wpdetail?wallpaperId=${targetContent.wallpaperId}&pageSource=recommend`;
        break;
      case 'wpauthorlist':
        url = `${CONTEXT}/wpauthorlist`;
        break;
      case 'wpcategory':
        url = `${CONTEXT}/wallpaper/wpcategory?classId=${targetContent.classId || ''}&tagId=${
          targetContent.tagId || ''
        }&colorId=${targetContent.colorId || ''}&wpSource=lookaround`;
        break;
      case 'softrank':
        url = `${CONTEXT}/rankmore?code=${targetContent.code}`;
        break;
      case 'speciallist':
        url = `${CONTEXT}/speciallist?pageType=${'recommend'}&ztType=${targetContent.ztType}&tag=${
          targetContent.tag
        }`;
        break;
      case 'special':
        url = `${CONTEXT}/special?ztId=${targetContent.ztId}&bannerId=${
          targetContent.pageCardContentId || ''
        }`;
        break;
      case 'category':
        url = `${CONTEXT}/category?code=${targetContent.code || ''}&classId=${
          targetContent.classId || ''
        }&tagId=${targetContent.tagId || ''}`;
        break;
      case 'otherpage':
        url = `${CONTEXT}/otherpage?pageUrl=${targetContent.pageUrl}`;
        break;
      case 'forumlist':
        url = `${CONTEXT}${MICROCONTEXT}${MICROCONTEXT}/`;
        break;
      case 'forumdetail':
        url = `${CONTEXT}${MICROCONTEXT}${MICROCONTEXT}/forumdetail?id=${targetContent.id || ''}`;
        break;
      default:
        url = `${CONTEXT}/`;
        break;
    }
  }

  return url;
}

export function addCookie(sName, sValue, day) {
  const expireDate = new Date();
  expireDate.setDate(expireDate.getDate() + day);
  // 设置失效时间
  document.cookie = `${escape(sName)}=${escape(sValue)};expires=${expireDate.toGMTString()}`;
}

// 封装客户端存取数据接口
export function indeSetData(key, value) {
  if (key && window.external && window.external.inde_set_kivi && window.external.inde_get_kivi) {
    window.external.inde_set_kivi(JSON.stringify({ ki: key, vi: value || '' }));
    logNative(
      `调用客户端 inde_set_kivi 方法存数据 ${JSON.stringify({
        ki: key,
        vi: encodeURI(value || ''),
      })}`,
    );
  } else {
    logNative(
      `调用客户端 inde_set_kivi 方法存数据失败，方法不存在 ${JSON.stringify({
        ki: key,
        vi: value || '',
      })}`,
    );
  }
}
// 封装客户端存取数据接口
export function indeGetData(key) {
  let dataObj = { ki: key, vi: '' };
  if (key && window.external && window.external.inde_set_kivi && window.external.inde_get_kivi) {
    let dataObjStr = window.external.inde_get_kivi(JSON.stringify({ ki: key }));

    if (dataObjStr) {
      try {
        dataObj = JSON.parse(dataObjStr);
      } catch (err) {
        logNative(
          `调用客户端 inde_get_kivi 方法获取数据失败 ${JSON.stringify({ ki: key })} ${err}`,
        );
      }
    }
  } else {
    logNative(
      `调用客户端 inde_get_kivi 方法获取数据失败 window.external.inde_get_kivi方法不存在 key: ${key}`,
    );
  }
  return dataObj?.vi || '';
}

/**
 * 用于本地存储数据，解决有时候localStorage取数据不成功的问题
 * @param {*} key
 * @param {*} value
 */
export function localSetItem(key, value) {
  indeSetData(key, value);
  localStorage.setItem(key, value);
}

/**
 * 用于本地存储数据，解决有时候localStorage取数据不成功的问题
 * @param {*} key
 */
export function localGetItem(key) {
  // return indeGetData(key);
  let value = '';
  let value_inde = indeGetData(key);
  let value_local = localStorage.getItem(key);
  if (value_inde && !value_local) {
    value = value_inde;
    localStorage.setItem(key, value_inde);
  }
  if (!value_inde && value_local) {
    value = value_local;
    indeSetData(key, value_local);
  }
  // 如果两个值都存在 又不相同
  if (value_inde && value_local) {
    value = value_inde;
    if (value_inde != value_local) {
      localStorage.setItem(key, value_inde);
    }
  }
  return value;
}

export function sortSoftsByLocalSoftInit(softs, localSoftsInit) {
  const softArr = [];
  softs.forEach((item, index) => {
    const found = localSoftsInit.find(
      soft =>
        (soft.androidType !== '1' &&
          (soft.softID === item.softID || soft.SoftID === item.softID)) ||
        (soft.androidType === '1' && soft.packageName === item.packageName),
    );
    softArr.push({ ...item, sortByLocalSoftsInit: found ? 100000 + index : index });
  });
  softArr.sort((a, b) => {
    return a.sortByLocalSoftsInit - b.sortByLocalSoftsInit;
  });
  return softArr;
}

export function formatMoney(money) {
  try {
    money = parseFloat(money);
    let unit = '';
    let num = parseFloat(money);
    if (money >= 10000) {
      num = money / 10000;
      unit = '万';
      if (money % 10000) {
        num = num.toFixed(2);
      }
      return `${parseFloat(num)}${unit}`;
    } else if (money < 10000) {
      num = num.toFixed(2);
      return `${parseFloat(num)}`;
    }
    return num;
  } catch (err) {
    return money;
  }
}

export function formatNumber(num) {
  // if (num > 1000000) {
  //   return `${(num / 1000000).toFixed(1)}M`;
  // } else
  if (num >= 10000) {
    return `${(num / 10000).toFixed(1)}W`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}K`;
  }
  return num;
}

export function byteLength(str) {
  let count = 0;
  for (let i = 0; i < str.length; i += 1) {
    if (str.charCodeAt(i) > 255) {
      count += 2;
    } else {
      count += 1;
    }
  }
  return count;
}

export function scrollingDom(dom, toNum = 0, speed = 5) {
  if (!dom) {
    return;
  }
  !window.requestAnimationFrame && this.initRequestAnimationFrame();
  let scroll = null;
  const fromNum = dom?.scrollTop;
  const toNumMax = dom?.scrollHeight;
  if (toNum < 0) {
    toNum = 0;
  }
  if (toNumMax < toNum) {
    toNum = toNumMax;
  }
  if (fromNum > toNum) {
    // 向上移动
    scroll = () => {
      const index = window.requestAnimationFrame(() => {
        window.cancelAnimationFrame(index);
        if (dom.scrollTop > toNum) {
          scroll();
          dom.scrollTop -= speed;
        }
      });
    };
  } else {
    // 向下移动
    scroll = () => {
      const index = window.requestAnimationFrame(() => {
        window.cancelAnimationFrame(index);
        if (dom.scrollTop + speed < toNum) {
          scroll();
          dom.scrollTop += speed;
        }
      });
    };
  }
  scroll();
}

export function initRequestAnimationFrame() {
  if (window.requestAnimationFrame) {
    return;
  }
  if (window.webkitRequestAnimationFrame) {
    window.requestAnimationFrame = window.webkitRequestAnimationFrame;
    window.cancelAnimationFrame = window.webkitCancelAnimationFrame
      ? window.webkitCancelAnimationFrame
      : window.webkitCancelRequestAnimationFrame;
    return;
  }
  if (window.mozRequestAnimationFrame) {
    window.requestAnimationFrame = window.mozRequestAnimationFrame;
    window.cancelAnimationFrame = window.mozCancelAnimationFrame
      ? window.mozCancelAnimationFrame
      : window.mozCancelRequestAnimationFrame;
    return;
  }
  let lastTime = 0;
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback) {
      const currTime = new Date().getTime();
      const timeToCall = Math.max(0, 16 - (currTime - lastTime));
      const id = window.setTimeout(() => {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
}

export function clientOS() {
  const sUserAgent = navigator.userAgent;
  const isWinPlatform = navigator.platform === 'Win32' || navigator.platform === 'Windows';
  const isMac =
    navigator.platform === 'Mac68K' ||
    navigator.platform === 'MacPPC' ||
    navigator.platform === 'Macintosh' ||
    navigator.platform === 'MacIntel';
  if (isMac) return 'Mac';
  const isUnix = navigator.platform === 'X11' && !isWinPlatform && !isMac;
  if (isUnix) return 'Unix';
  const isLinux = String(navigator.platform).indexOf('Linux') > -1;
  if (isLinux) return 'Linux';
  if (isWinPlatform) {
    const isWin2K =
      sUserAgent.indexOf('Windows NT 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1;
    if (isWin2K) return 'win2000';
    const isWinXP =
      sUserAgent.indexOf('Windows NT 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1;
    if (isWinXP) return 'winxp';
    let isWin =
      sUserAgent.indexOf('Windows NT 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1;
    if (isWin) return 'win2003';
    isWin = sUserAgent.indexOf('Windows NT 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1;
    if (isWin) return 'vista';
    isWin = sUserAgent.indexOf('Windows NT 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1;
    if (isWin) return 'win7';
    isWin = sUserAgent.indexOf('Windows NT 8.1') > -1 || sUserAgent.indexOf('Windows 8') > -1;
    if (isWin) return 'win8';
    isWin = sUserAgent.indexOf('Windows NT 10.0') > -1 || sUserAgent.indexOf('Windows 10') > -1;
    if (isWin) return 'win10';
  }
  return 'None';
}

export function isBigger() {
  const type = sessionStorage.getItem('PCStoreIsMaximize') || '0';
  if (type === '0' && (document.body.clientWidth !== 1060 || document.body.clientHeight !== 680)) {
    return 2;
  }
  return type;
}

export function assignParam1(param1 = {}, machineInfos = {}, commandLine = '') {
  const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO) || '{}') || {};
  const userInfo = JSON.parse(localStorage.getItem(cacheKeys.USER_INFO) || '{}') || {};
  // 拿取machineInfo信息
  let machineInfo = JSON.parse(localStorage.getItem(cacheKeys.LOCALMACHINE_INFO) || '{}');
  machineInfo = Object.assign(machineInfo, param1);
  machineInfo = Object.assign(machineInfo, machineInfos);
  const date = new Date();
  const logtime = `${date.getFullYear()}-${
    date.getMonth() + 1
  }-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;

  const param1New = {
    app_channel: startInfo.leas_channel || '',
    deviceid:
      machineInfo.MAC || machineInfo.SN || machineInfo.MACCABLE || machineInfo.ludp_uuid || '', //  默认采集设备id
    device_model: machineInfo.MT, //  设备型号
    device_type:
      (machineInfo.MAC && 'MAC') ||
      (machineInfo.SN && 'SN') ||
      (machineInfo.MACCABLE && 'MACCABLE') ||
      (machineInfo.ludp_uuid && 'UUID') ||
      '', // 设备号类型   设备号类型     否 设备类型：目前日志MACWIF...
    UUID: machineInfo.UUID,
    ludp_uuid: machineInfo.ludp_uuid,
    language: '', //  用户本机设置语言
    lenovoid: userInfo.uid || userInfo.lid || '', //  登录用户账号
    logtime, // 时间
    manufacturer: '', //  厂家
    network_type: '', //  网络类型
    origin: commandLine, //  来源    入口来源
    os_version: `${machineInfo.OS} ${machineInfo.OSbit}`, //  操作系统+位数
    osBuild: machineInfo.osBuild || '', //操作系统
    resolution: '', //  设备分辨率
    sessionid: window.PC_STORE_START_HTML_LOAD_END, // 会话id
    user_id: userInfo.realname || userInfo.uName || '', // 登录用户id
    // SN: startInfo.SN,
    isDStore: machineInfo.leas_runtime === 'independent' ? 1 : 0,
    storeMode: startInfo.storeMode || '',
    width: document.body.clientWidth,
    height: document.body.clientHeight,
    width_height: `${document.body.clientWidth} * ${document.body.clientHeight}`,
    isBig: isBigger(),
    // H5Version:
    //   machineInfo.leas_runtime === 'independent' ? `${APP_VERSION_D}_test` : `${APP_VERSION}_test`,
    // ClientVersion: `${startInfo.ClientVersion}_test`,
    H5Version: machineInfo.leas_runtime === 'independent' ? `${APP_VERSION_D}` : `${APP_VERSION}`,
    ClientVersion: startInfo.ClientVersion,
    scaling: startInfo.scaling || '',
  };

  // 下载应用需要带一些参数
  const installParam = `deviceModel=${encodeURIComponent(
    machineInfo.MT,
  )}&lenovoId=${encodeURIComponent(userInfo.uid || userInfo.lid || '')}&userId=${encodeURIComponent(
    userInfo.realname || userInfo.uName || '',
  )}&sn=${encodeURIComponent(startInfo.SN)}&deviceId=${encodeURIComponent(
    machineInfo.MAC || machineInfo.SN || machineInfo.MACCABLE || machineInfo.ludp_uuid || '',
  )}&deviceType=${encodeURIComponent(
    (machineInfo.MAC && 'MAC') ||
      (machineInfo.SN && 'SN') ||
      (machineInfo.MACCABLE && 'MACCABLE') ||
      (machineInfo.ludp_uuid && 'UUID') ||
      '',
  )}&clientVersion=${encodeURIComponent(startInfo.ClientVersion)}&appVersion=${encodeURIComponent(
    APP_VERSION,
  )}&appVersionCode=${encodeURIComponent(APP_VERSION_CODE)}`;

  localStorage.setItem(cacheKeys.INSTALL_PARAM, installParam);
  return param1New;
}

export function logInit(machineInfo) {
  window.Avatar &&
    window.Avatar.push({
      appKey: 'L1O38A4LVF13', // 项目appkey，此项目appKey：L1O38A4LVF13
      pageId: 'PC_Store_Register', // 页面标识
      deviceId:
        machineInfo.MAC || machineInfo.SN || machineInfo.MACCABLE || machineInfo.ludp_uuid || '',
      deviceModel: machineInfo.MT, //  设备型号
      versionName: machineInfo.leas_runtime === 'independent' ? APP_VERSION_D : APP_VERSION,
      versionCode:
        machineInfo.leas_runtime === 'independent' ? APP_VERSION_CODE_D : APP_VERSION_CODE,
    });
}

export function logging(info, machineInfo, commandLine) {
  let param1 = assignParam1(info.param1 || {}, machineInfo, commandLine);

  // 特殊处理，如果非Action调用logging，则param1 使用localStroge中的值
  // if (!machineInfo && !commandLine) {
  //   const param1Str = localStorage.getItem(cacheKeys.LOG_PARAM1);
  //   try {
  //     param1 = JSON.parse(param1Str);
  //   } catch (error) {
  //     logNative(`logging JSON格式错误${error}`, error);
  //   }
  // } else {
  //   localStorage.setItem(cacheKeys.LOG_PARAM1, JSON.stringify(param1));
  // }

  // 获取设备初始信息
  let param4 = {};
  try {
    const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO));
    param4 = {
      MainLoadEndTime: startInfo?.MainLoadEndTime,
      MainLoadStartTime: startInfo?.MainLoadStartTime,
      SessionID: startInfo?.SessionID,
    };
    if (param4 && param4.MainLoadEndTime && param4.MainLoadStartTime) {
      param4.mainLoadTime =
        parseInt(param4.MainLoadEndTime, 10) - parseInt(param4.MainLoadStartTime, 10);
    }
  } catch (error) {
    logNative(`logging JSON格式错误${error}`, error);
  }
  let param3 = info.param3;
  try {
    if (param3 && typeof param3 === 'string') {
      let param3_ = JSON.parse(param3);
      param3 = JSON.stringify(param3_);
    }
    if (param3 && typeof param3 === 'object') {
      param3 = JSON.stringify(param3);
    }
  } catch (error) {
    logNative(`logging param3 JSON格式错误 ${JSON.stringify(param3)} ${error}`, error);
    param3 = info.param3;
  }

  window.Avatar &&
    window.Avatar.push([
      'track',
      [
        info.category, // 事件的分类名称
        info.action, // 事件分类下的行为名称
        info.label, // 事件的说明
        {
          arg1: JSON.stringify(param1), // 默认为设备信息
          arg2: JSON.stringify(info.param2 || {}), // 页面信息
          arg3: param3 || '', // 服务端透传信息bizInfo
          arg4: JSON.stringify(param4 || info.param4 || {}), // sessionID
          arg5: JSON.stringify(info.param5 || {}),
        },
      ],
    ]);
}

/**
 * 前端日志记录 文件记录和云端记录
 * @param {*} method
 * @param {*} params
 */
export const logNative = (method, params, isLogObj, isOnlyLog) => {
  try {
    // 是否打印出数据对象
    if (isLogObj) {
      console.log(
        `主项目日志 ${method}, time: ${+new Date()} -time: ${
          +new Date() - window.PC_STORE_START_HTML_LOAD_END
        }`,
        params,
      );
    } else {
      console.log(
        `主项目日志 ${method}, param: ${JSON.stringify(params || '{}')}, pageID: ${
          window.PC_STORE_START_HTML_LOAD_END
        } time: ${new Date()} ${+new Date()} -time: ${
          +new Date() - window.PC_STORE_START_HTML_LOAD_END
        }`,
      );
    }
    // 2021-8-26 16:13:30  调整，不再上报
    // if (isOnlyLog) {
    //   return;
    // }
    // const ua = window.localStorage.getItem(cacheKeys.USER_TOKEN);
    // const token = window.localStorage.getItem(cacheKeys.REGISTER_TOKEN);
    // Axios.create()
    //   .post(REPORT_LOG_URL, {
    //     time: Date.now(),
    //     level: 'ERROR',
    //     serviceName: method,
    //     whichProduct: 'lenovostore',
    //     cppversion: '',
    //     h5version: APP_VERSION,
    //     useragent: ua,
    //     headers: token,
    //     message: `日志信息：${JSON.stringify(params || '{}')}`,
    //   })
    //   .catch(error => {
    //   });
  } catch (error) {}
};

// 获取字符串实际长度
export const getStrLen = str => {
  let blen = 0;
  for (let i = 0; i < str.length; i++) {
    if ((str.charCodeAt(i) & 0xff00) != 0) {
      blen++;
    }
    blen++;
  }
  return blen;
};

/***********************************************/
/*
自定义sentry上报错误
test: 上报错误的内容，
extra: 需要上报错误的数据
level: 错误的等级(warning, error)
*/

export const setSentryErr = info => {
  Sentry.captureMessage(info?.test, {
    extra: info?.extra,
    level: info?.level,
  });
};

// 另一种自定义事件的上报,这个是可以放到请求中，目前可能暂时用不上，当前我们平台暂时没有看到span目录需要后续再研究
export const setDiySentryErr = info => {
  // 我们可以在请求前创建一个事务，以及一个span
  const transaction = Sentry.startTransaction({ name: info?.name });
  // 将创建的事务附带到当前 sentry 上下文
  Sentry.getCurrentHub().configureScope(scope => scope.setSpan(transaction));
  // 创建一个 span 并塞到事务里，这里的 op 和 description 你可以都用接口名来做区分
  const span = transaction.startChild({
    data: {
      // 你想附带的数据
    },
    op: '', // 操作名
    description: '', // 描述
  });

  return { span, transaction };
};

// 如果调用了上面的方法再请求结束以后需要调用finish上报错误, 这里的结果只能放入上面方法return的结果
export const finishDiySentryErr = info => {
  const { span, transaction } = info;
  span.finish();
  transaction.finish();
};

/***********************************************/

/**
 * 将数据插入数组元素中height最小的那一项,更新数组中height值，返回新的数组
 */
export function setItemToShortestList(list, item) {
  let num = null;
  let index = null;
  for (let i = 0; i < list.length; i++) {
    if (num === null) {
      num = list[i].height;
      index = i;
    } else {
      if (num > list[i].height) {
        index = i;
        num = list[i].height;
      }
    }
  }
  const listItem = { ...item, top: list[index].height };
  list[index].height += item.height + 16;
  list[index].cardList.push(listItem);
  return list;
}

/**
 * 根据type 确定卡片style采用哪种（非游戏，游戏色调0，游戏色调1）
 * @param item 列表项
 * @return insertedItem 转换完成的item
 */
export function changeItemStyleTypeDependOnType(item) {
  const { type } = item;
  if (type !== 1) {
    item.styleType = 'line-item';
    return item;
    // return { ...item, styleType: 2 };
  }
  const radomNum = Math.round(Math.random());
  item.styleType = ['game', `game${radomNum}`];
  return item;
}

/**
 * 格式化毫秒时间戳为时分秒格式
 */
export function formatTimestampToRemainTime(timestamp) {
  const d = Math.floor(timestamp / 86400000);
  if (d >= 7) {
    return null;
  }
  let remainderNum = timestamp % 86400000;
  const h = Math.floor(remainderNum / 3600000);
  remainderNum = remainderNum % 3600000;
  const min = Math.floor(remainderNum / 60000);
  remainderNum = remainderNum % 60000;
  const s = Math.floor(remainderNum / 1000);
  remainderNum = remainderNum % 1000;

  return d + '天' + h + '时' + min + '分';
}
